import React, { useEffect, useState } from "react";
import "./ForgotPasswordForm.scss";
import { forgotPassword, getPasswordCodeMobile } from "../../util/API/customers";
import { Button, Box, TextField } from "@mui/material";
import { getPasswordCode, setNewPassword } from "../../util/API/customers";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useSelector } from "react-redux";

function ForgotPasswordForm({ toggleRecovery }) {
  const [userName, setUsername] = useState("");
  const [error, setError] = useState(null);
  const [displayError, setDisplayError] = useState(false);
  const [errorColor, setErrorColor] = useState("red");
  const [sentToken, setSentToken] = useState(false);
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userID, setUserID] = useState("")
  const [changeSuccess, setChangeSuccess] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState({
    password: false,
    confirmPassword: false
  });
  const [enabled, setEnabled] = useState({
    sendpassword: true,
    confirmPassword: true
  });
  let configVariables = useSelector((state) => state.config.baseConfig);
  var allowedSecurityRoles = configVariables.allowed_security_roles;

  useEffect(() => {
    setError(null);
    setDisplayError(false);

    if (!sentToken) {
      setUsername("");
      setPassword("");
      setConfirmPassword("");
      setToken("");
    }
  }, [sentToken]);

  async function handleFormSubmit(e) {
    setDisplayError(false);
    e.preventDefault();
    let response
    response = await forgotPassword(userName);

    if (response.callStatus === "1") {
      setError("A new password has been sent to the email");
      setDisplayError(true);
      setErrorColor("green");
    } else {
      setErrorColor("red");

      let error = response.payload.msg;
      setError(error);
      setDisplayError(true);
    }
    //   let firstViablePath = response.access[0].label.split(" ")[1].toLowerCase();
    //   console.log(response.access[0].label.split(" ")[1]);
    //   if (callStatus == 1) {
    //     dispatch(setLoggedInUser(response));
    //     setLoggedIn(false);
    //     navigate(`/${firstViablePath}`, { replace: true });
    //     sessionStorage.setItem("user", JSON.stringify(response));
    //   } else {
    //     setLoggedIn(true);
    //     console.log("failed");
    //   }
    //   // setUserData(response);
    //   // auth.login(response);
  }

  const handleSubmitButton = async() => {
    setEnabled({
      ...enabled,
      sendpassword: false,
    })
    let response
    let formattedUsername = userName
    if (formattedUsername.includes("@4pay.ph")) {
      response = await getPasswordCodeMobile(userName);
    }
    else {
      response = await getPasswordCode(userName);
    }
    if (response.callStatus === "1") {
      console.log("handleSubmitButton_response================",response);

      // ======== Check for allowed roles from config and accordingly allow user to login. =========
      const hasWildcard = allowedSecurityRoles.includes('*');
      const userRoles =  response?.userroledata?.Securityuserrole;
      console.log("handleSubmitButton_userRoles================",userRoles);
      const userRolesArray = Array.isArray(userRoles) ? userRoles : [userRoles];
      const userRoleIds = userRolesArray
      .map(role => role?.roleid?.toString())
      .filter(Boolean);
      // Check if there's any match between userRoleIds and allowedSecurityRoles
      const hasMatch = hasWildcard || userRoleIds.some(roleId => allowedSecurityRoles.includes(roleId));
      console.log("handleSubmitButton_hasMatch================",hasMatch);

      if (hasMatch) {
        console.log("Matched");
      } else {
        setError("Unauthorized access");
        setDisplayError(true);
        setChangeSuccess(true)
        setErrorColor("red");
        return;
      }
      // ================================================================================================

      setError("A token has been sent to the email");
      setDisplayError(true);
      setErrorColor("green");
      setSentToken(true);
      setUserID(response?.userid)
      setEnabled({
        ...enabled,
        sendpassword: true,
      })    
    }
    else {
      setError(response.msg);
      setDisplayError(true);
      setErrorColor("red");
      setEnabled({
        ...enabled,
        sendpassword: true,
      })    
    }
  }

  const handlePasswordChange = async() => {
    setEnabled({
      ...enabled,
      confirmPassword: false,
    })
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      setDisplayError(true);
      setErrorColor("red");
      setEnabled({
        ...enabled,
        confirmPassword: true,
      })
      return;
    }

    let response = await setNewPassword(userID, token, password, userName);
    if (response.callStatus === "1") {
      setError("Your password has been reset successfully!");
      setDisplayError(true);
      setErrorColor("green");
      setChangeSuccess(true)
      setEnabled({
        ...enabled,
        confirmPassword: true,
      })
    }
    else {
      setError(response.msg);
      setDisplayError(true);
      setErrorColor("red");
      setEnabled({
        ...enabled,
        confirmPassword: true,
      })
    }
  }


  return (
    <Box>
      <Box className="login-label">Recover Password</Box>
      {sentToken ? (
        changeSuccess ? (
          <>
          {displayError && (
            <Box style={{ color: errorColor }} className="mb-3">
              {error}
            </Box>
          )}
            <div className="sign-in-here-text pointer" onClick={toggleRecovery}>
              Sign-In Here
            </div>
          </>
        ) :(
      <>
        <form onSubmit={handleFormSubmit}>
          <Box>
            <TextField
              className="login-input"
              name="token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              // placeholder="Token"
              label="Token"
              type="number"
            />
            
             <TextField
              className="login-input"
              name="newpassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              // placeholder="New Password"
              label="New Password"
              type={passwordVisible.password ? "text" : "password"}
            />
            <span onClick={() => setPasswordVisible({...passwordVisible, password: !passwordVisible.password})} className="visible-icon">
              {passwordVisible.password ? <FaEyeSlash /> : <FaEye />}
            </span>

             <TextField
              className="login-input"
              name="retypepassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              // placeholder="Retype Password"
              label="Retype Password"
              type={passwordVisible.confirmPassword ? "text" : "password"}
            />
            <span onClick={() => setPasswordVisible({...passwordVisible, confirmPassword: !passwordVisible.confirmPassword})} className="visible-icon">
              {passwordVisible.confirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </Box>
          <Box></Box>
          {displayError && (
            <Box style={{ color: errorColor }} className="mb-3">
              {error}
            </Box>
          )}

          <Box className="login-button-container">
            <Box className="sign-in-here-text pointer" onClick={() => setSentToken(false)}>
              Back
            </Box>
            <Box></Box>
            <Box>
              <Button 
                className="send-password-button"
                onClick={() => handlePasswordChange()}
                disabled={!enabled.confirmPassword}
                sx={{
                  borderRadius: "50px",
                  background: "#F9C801",
                  color: "white",
                  border: "none",
                  padding: "9px 18px",
                  '&:hover': {
                    backgroundColor: '#FAD43A', // Slightly lighter shade on hover
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#BDBDBD',
                    cursor: 'auto',
                  },
                }}
              >Set Password</Button>
            </Box>
          </Box>
        </form>
      </>
      )
      ) : (
        <>
          <form onSubmit={handleFormSubmit}>
            <Box sx={{flexDirection: "column"}}>
               <TextField
                className="login-input"
                name="username"
                value={userName}
                onChange={(e) => setUsername(e.target.value)}
                label="Enter Username"
              />
            </Box>
            <Box></Box>
            {displayError && (
              <Box style={{ color: errorColor }} className="mb-3">
                {error}
              </Box>
            )}

            <Box className="login-button-container">
              <Box className="sign-in-here-text pointer" onClick={toggleRecovery}>
                Go Back
              </Box>
              <Box></Box>
              <Box>
                <Button 
                  className="send-password-button"
                  onClick={() => handleSubmitButton()}
                  disabled={!enabled.sendpassword}
                  sx={{
                    borderRadius: "50px",
                    background: "#F9C801",
                    color: "white",
                    border: "none",
                    padding: "9px 18px",
                    '&:hover': {
                      backgroundColor: '#FAD43A', 
                    },
                    '&.Mui-disabled': {
                      backgroundColor: '#BDBDBD',
                      cursor: 'auto',
                    },
                  }}
                >Send Password</Button>
              </Box>
            </Box>
          </form>
        </>
      )}
    </Box>
  );
}

export default ForgotPasswordForm;
